module.exports = __webpack_public_path__ + "img/coupon_three.abdab9cc.webp";